/* eslint-disable max-lines-per-function */
import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, renderPrice, EmptyCell, Title, colors
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const NorthView = ({ data, matrixType }) => (
    <Table celled compact>

        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='North View' />
            </Table.Row>
            <Table.Row>
                <Header />
                {headers.northView.floorPlans.map(floorPlan => <Header colSpan='2' content={floorPlan} />)}
            </Table.Row>

            <Table.Row>
                <Header />
                {headers.northView.floorPlans.map(() => <Header colSpan='2' content='sqft' />)}
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {
                range(8, 3, -1)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map((floor, i) => (
                        <Table.Row key={`north-${i}`}>
                            <Table.Cell singleLine content={`${floor.split('').pop()}th floor`} />
                            {
                                ['08', '06', '04', '02', '32', '31', '30', '29', '28', '12', '14'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} style={{ backgroundColor: data[`1-${floor}${unitNumber}`].growth_rate_not_configured }}/>
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }

            <Table.Row>
                <Table.Cell />
                <EmptyCell count={4} />
                <Table.Cell colSpan='2' content='LOFT1-3/2' />
                <Table.Cell colSpan='2' content='LOFT2-3/2' />
                <Table.Cell colSpan='2' content='LOFT3-3/2' />
                <EmptyCell />
                <Table.Cell colSpan='2' content='LOFT4-3/2' />
                <EmptyCell />
                <EmptyCell />
            </Table.Row>
            <Table.Row>
                <Table.Cell />
                <EmptyCell count={4} />
                <Table.Cell colSpan='2' content='sqft' />
                <Table.Cell colSpan='2' content='sqft' />
                <Table.Cell colSpan='2' content='sqft' />
                <EmptyCell />
                <Table.Cell colSpan='2' content='sqft' />
                <EmptyCell />
                <EmptyCell />
            </Table.Row>
            <Table.Row>
                <Table.Cell />
                <EmptyCell count={4} />
                <Table.Cell content='L1' />
                <Table.Cell
                    content={renderPrice(data['1-L1'], matrixType)}
                    style={{ backgroundColor: colors[data['1-L1'].status] }}
                />
                <Table.Cell content='L2' />
                <Table.Cell
                    content={renderPrice(data['1-L2'], matrixType)}
                    style={{ backgroundColor: colors[data['1-L2'].status] }}
                />
                <Table.Cell content='L3' />
                <Table.Cell
                    content={renderPrice(data['1-L3'], matrixType)}
                    style={{ backgroundColor: colors[data['1-L3'].status] }}
                />
                <EmptyCell />
                <Table.Cell content='L4' />
                <Table.Cell
                    content={renderPrice(data['1-L4'], matrixType)}
                    style={{ backgroundColor: colors[data['1-L4'].status] }}
                />
                <EmptyCell />
                <EmptyCell />
            </Table.Row>
        </Table.Body>

    </Table>
);

const SouthView = ({ data, matrixType }) => (
    <Table celled compact>

        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='South View' />
            </Table.Row>
            <Table.Row>
                <Header />
                <Header colSpan='2' content='B2-2/2' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' />
                <Header colSpan='2' />
                <Header colSpan='2' content='A1-1/1' />
                <Header colSpan='2' content='A1-1/1' />
                <Header colSpan='2' content='A1-1/1' />
                <Header colSpan='2' />

            </Table.Row>
            <Table.Row>
                <Header />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' />
                <Header colSpan='2' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' />

            </Table.Row>
        </Table.Header>

        <Table.Body>
            <Table.Row>
                <Table.Cell content='1st Floor'/>
                <Table.Cell content='104'/>
                <Table.Cell
                    content={renderPrice(data['1-0104'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0104'].status] }}
                />
                <Table.Cell content='103'/>
                <Table.Cell
                    content={renderPrice(data['1-0103'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0103'].status] }}
                />
                <Table.Cell content='102'/>
                <Table.Cell
                    content={renderPrice(data['1-0102'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0102'].status] }}
                />
                <Table.Cell content='101'/>
                <Table.Cell
                    content={renderPrice(data['1-0101'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0101'].status] }}
                />
                <Table.Cell colSpan='2'/>
                <Table.Cell colSpan='2'/>

                <Table.Cell content='105'/>
                <Table.Cell
                    content={renderPrice(data['1-0105'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0105'].status] }}
                />
                <Table.Cell content='106'/>
                <Table.Cell
                    content={renderPrice(data['1-0106'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0106'].status] }}
                />
                <Table.Cell content='107'/>
                <Table.Cell
                    content={renderPrice(data['1-0107'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0107'].status] }}
                />
                <Table.Cell colSpan='2'/>

            </Table.Row>


            <Table.Row>
                <Table.Cell />
                {headers.southView.floorPlans.map(floorPlan => <Table.Cell textAlign='center' colSpan='2' content={floorPlan} />)}
            </Table.Row>

            <Table.Row>
                <Table.Cell />
                {headers.southView.floorPlans.map(() => <Table.Cell textAlign='center' colSpan='2' content='sqft' />)}
            </Table.Row>

            {
                range(4, 9)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map(floor => (
                        <Table.Row>
                            <Table.Cell singleLine content={`${floor.split('').pop()}th floor`} />
                            {
                                ['10', '09', '07', '05', '03', '01', '11', '13', '15', '16'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} style={{ backgroundColor: data[`1-${floor}${unitNumber}`].growth_rate_not_configured }} />
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }

            <Table.Row>
                <Table.Cell content='9th Floor' />
                <EmptyCell count={5} />
                <Table.Cell content='0901' />
                <Table.Cell
                    content={renderPrice(data['1-0901'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0901'].status] }}
                />
                <Table.Cell content='0911' />
                <Table.Cell
                    content={renderPrice(data['1-0911'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0911'].status] }}
                />
            </Table.Row>
            <Table.Row>
                <Table.Cell content='10th Floor' />
                <EmptyCell count={5} />
                <Table.Cell content='1001' />
                <Table.Cell
                    content={renderPrice(data['1-1001'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1001'].status] }}
                />
                <Table.Cell content='1011' />
                <Table.Cell
                    content={renderPrice(data['1-1011'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1011'].status] }}
                />
            </Table.Row>
            <Table.Row>
                <Table.Cell content='11th Floor' />
                <EmptyCell count={5} />
                <Table.Cell content='1101' />
                <Table.Cell
                    content={renderPrice(data['1-1101'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1101'].status] }}
                />
                <Table.Cell content='1111' />
                <Table.Cell
                    content={renderPrice(data['1-1111'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1111'].status] }}
                />
            </Table.Row>
            <Table.Row>
                <Table.Cell content='12th Floor' />
                <EmptyCell count={5} />
                <Table.Cell content='1201' />
                <Table.Cell
                    content={renderPrice(data['1-1201'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1201'].status] }}
                />
                <Table.Cell content='1211' />
                <Table.Cell
                    content={renderPrice(data['1-1211'], matrixType)}
                    style={{ backgroundColor: colors[data['1-1211'].status] }}
                />
            </Table.Row>


        </Table.Body>

    </Table>

);

const EastView = ({ data, matrixType }) => (
    <Table attached='top' celled compact>

        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='East View' />
            </Table.Row>
            <Table.Row>
                <Header />
                <Header colSpan='2' content='B3-2/2' />
                <Header colSpan='2' content='B3-2/2' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='C2-3/2' />
                <Header colSpan='2' />
            </Table.Row>
            <Table.Row>
                <Header />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' />
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {
                range(12, 10, -1)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map(floor => (
                        <Table.Row>
                            <Table.Cell singleLine content={`${floor}th floor`} />
                            {
                                ['17', '19', '21', '23', '25'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} style={{ backgroundColor: data[`1-${floor}${unitNumber}`].growth_rate_not_configured }}/>
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }

            <Table.Row>
                <Table.Cell />
                <Table.Cell colSpan='2' textAlign='center' content='B3-2/2' />
                <Table.Cell colSpan='2' textAlign='center' content='B3-2/2' />
                <Table.Cell colSpan='2' textAlign='center' content='A2-1/1' />
                <Table.Cell colSpan='2' textAlign='center' content='A2-1/1' />
                <Table.Cell colSpan='2' textAlign='center' content='A2-1/1' />
                <Table.Cell colSpan='2' textAlign='center' content='A2-1/1' />
            </Table.Row>
            <Table.Row>
                <Table.Cell />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
                <Table.Cell colSpan='2' textAlign='center' content='sqft' />
            </Table.Row>
            <Table.Row>
                <Table.Cell singleLine content={'10th floor'} />
                {
                    ['17', '19', '21', '23', '25', '27'].map(unitNumber => (
                        <>
                            <Table.Cell content={`10${unitNumber}`} />
                            <Table.Cell
                                content={renderPrice(data[`1-10${unitNumber}`], matrixType)}
                                style={{ backgroundColor: colors[data[`1-10${unitNumber}`].status] }}
                            />
                        </>
                    ))
                }

            </Table.Row>
            <Table.Row>
                <Table.Cell singleLine content={'9th floor'} />
                {
                    ['17', '19', '21', '23'].map(unitNumber => (
                        <>
                            <Table.Cell content={`09${unitNumber}`} />
                            <Table.Cell
                                content={renderPrice(data[`1-09${unitNumber}`], matrixType)}
                                style={{ backgroundColor: colors[data[`1-09${unitNumber}`].status] }}
                            />
                        </>
                    ))
                }

                <Table.Cell textAlign='center' colSpan='4' style={{ backgroundColor: 'red' }} content='PARTY ROOM'/>


            </Table.Row>
            {
                range(8, 3, -1)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map(floor => (
                        <Table.Row>
                            <Table.Cell singleLine content={`${floor.split('').pop()}th floor`} />
                            {
                                ['17', '19', '21', '23', '25', '27'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} style={{ backgroundColor: data[`1-${floor}${unitNumber}`].growth_rate_not_configured }}/>
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }


        </Table.Body>

    </Table>
);

const WestView = ({ data, matrixType }) => (
    <Table attached='top' celled compact>

        <Table.Header>
            <Table.Row>
                <Header colSpan='100' content='West View' />
            </Table.Row>
            <Table.Row>
                <Header colSpan='3' />
                <Header colSpan='2' content='B1(T)-2/2' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='A2-1/1' />
                <Header colSpan='2' content='D1-2/1' />
                <Header colSpan='2' content='B4-2/2' />
            </Table.Row>
            <Table.Row>
                <Header colSpan='3' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
                <Header colSpan='2' content='sqft' />
            </Table.Row>
        </Table.Header>

        <Table.Body>

            <Table.Row>
                <Table.Cell content='4th Floor'/>
                <Table.Cell colSpan='2'/>
                <Table.Cell content='420' />
                <Table.Cell
                    content={renderPrice(data['1-0420'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0420'].status] }}
                />
                <Table.Cell content='422' />
                <Table.Cell
                    content={renderPrice(data['1-0422'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0422'].status] }}
                />
                <Table.Cell content='424' />
                <Table.Cell
                    content={renderPrice(data['1-0424'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0424'].status] }}
                />
                <Table.Cell content='426' />
                <Table.Cell
                    content={renderPrice(data['1-0426'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0426'].status] }}
                />
                <Table.Cell content='433' />
                <Table.Cell
                    content={renderPrice(data['1-0433'], matrixType)}
                    style={{ backgroundColor: colors[data['1-0433'].status] }}
                />
            </Table.Row>


            <Table.Row>
                <Table.Cell textAlign='center' />
                <Table.Cell textAlign='center' colSpan='2' content='B3-2/2' />
                <Table.Cell textAlign='center' colSpan='2' content='B3-2/2' />
                <Table.Cell textAlign='center' colSpan='2' content='A2-1/1' />
                <Table.Cell textAlign='center' colSpan='2' content='A2-1/1' />
                <Table.Cell textAlign='center' colSpan='2' content='D1-2/1' />
                <Table.Cell textAlign='center' colSpan='2' content='C1-3/2' />
            </Table.Row>
            <Table.Row>
                <Table.Cell textAlign='center' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
            </Table.Row>

            {
                range(5, 9)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map(floor => (
                        <Table.Row>
                            <Table.Cell singleLine content={`${floor.split('').pop()}th floor`} />
                            {
                                ['18', '20', '22', '24', '26', '33'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} />
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }


            <Table.Row>
                <Table.Cell textAlign='center' />
                <Table.Cell textAlign='center' colSpan='2' content='B3-2/2' />
                <Table.Cell textAlign='center' colSpan='2' content='B3-2/2' />
                <Table.Cell textAlign='center' colSpan='2' content='A2-1/1' />
                <Table.Cell textAlign='center' colSpan='2' content='A2-1/1' />
                <Table.Cell textAlign='center' colSpan='2' content='B3-2/2' />
                <Table.Cell textAlign='center' colSpan='2' />
            </Table.Row>
            <Table.Row>
                <Table.Cell textAlign='center' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2' content='sqft' />
                <Table.Cell textAlign='center' colSpan='2'/>
            </Table.Row>

            {
                range(9, 13)
                    .map(n => n.toLocaleString('en-US', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    }))
                    .map(floor => (
                        <Table.Row>
                            <Table.Cell singleLine content={`${floor.split('').pop()}th floor`} />
                            {
                                ['18', '20', '22', '24', '26'].map(unitNumber => (
                                    <>
                                        <Table.Cell content={`${floor}${unitNumber}`} />
                                        <Table.Cell
                                            content={renderPrice(data[`1-${floor}${unitNumber}`], matrixType)}
                                            style={{ backgroundColor: colors[data[`1-${floor}${unitNumber}`].status] }}
                                        />
                                    </>
                                ))
                            }

                        </Table.Row>
                    ))
            }

        </Table.Body>

    </Table>
);

const BrickellWestMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div>
            <div>
                <Trigger />
            </div>
            <div ref={ref} style={styles.root} className='print landscape'>

                <Title data={Object.values(data)} title='Brickell West'/>
                <PrintDate isForPDF={false}/>
                <NorthView data={data} matrixType={matrixType} />
                <SouthView data={data} matrixType={matrixType} />
                <div className='pagebreak' />
                <div className='printspace' />
                <EastView data={data} matrixType={matrixType} />
                <WestView data={data} matrixType={matrixType} />
            </div>
        </div>
    );

};

const headers = {
    northView: {
        floorPlans: ['B3-2/2', 'B3-2/2', 'B3-2/2', 'B3-2/2', 'B5-2/2', 'A2-1/1', 'A2-1/1', 'A2-1/1', '', 'B3-2/2', 'B3-2/2']
    },
    southView: {
        floorPlans: ['B2-2/2', 'A2-1/1', 'A2-1/1', 'A2-1/1', 'A2-1/1', 'B3-2/2', 'B3-2/2', 'A2-1/1', 'A2-1/1', 'A1(T)-1/1']
    }
};

export default BrickellWestMatrix;
